// Generated by scripts/generate-build-info.js — do not edit.
export default {
  "version": "1.0.0",
  "tag": null,
  "sha": "63a8f6d",
  "branch": "master",
  "dirty": true,
  "repo": "https://gitlab.ufpe.br/thiago.prazeres/design-system-ufpe",
  "commitUrl": "https://gitlab.ufpe.br/thiago.prazeres/design-system-ufpe/-/commit/63a8f6d",
  "tagUrl": null,
  "builtAt": "2026-05-17T22:24:49.050Z"
};
